'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getNumberOfCalendarMonthWeeks = {};

exports.__exports = getNumberOfCalendarMonthWeeks;
